import React from 'react';
import { Link } from 'react-router-dom';
import { getUserSession, isSuperAdmin } from '../services/authService';
import '../styles/admin.css';

const AdminConfiguracionPage = () => {
  const session = getUserSession();

  if (!session || !isSuperAdmin(session)) {
    return null;
  }

  return (
    <div className="admin-root">
      <section className="admin-section">
        <header className="admin-header">
          <div>
            <h1>Configuración</h1>
            <p>Maestros y datos que el sistema usa más adelante.</p>
          </div>
        </header>

        <div className="config-opciones">
          <Link to="/admin/configuracion/montos" className="admin-btn admin-btn--primary">
            Montos por estudio
          </Link>
          <p className="admin-muted">
            Precio que cobra cada especialista por estudio y, si aplica, el monto del asociado.
          </p>
          <Link to="/admin/configuracion/descuentos" className="admin-btn admin-btn--primary">
            Descuentos
          </Link>
          <p className="admin-muted">
            Tipos de descuento para inasistencias, incapacidades y vacaciones.
          </p>
        </div>
      </section>
    </div>
  );
};

export default AdminConfiguracionPage;
